var _excluded = ["children"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';

/* TYPES */

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */
/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */
/* HOOK */

function noop() {}

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */
export function useVisibility(_ref) {
  var _ref$afterHide = _ref.afterHide,
    afterHide = _ref$afterHide === void 0 ? noop : _ref$afterHide,
    _ref$afterShow = _ref.afterShow,
    afterShow = _ref$afterShow === void 0 ? noop : _ref$afterShow,
    _ref$initialIsVisible = _ref.initialIsVisible,
    initialIsVisible = _ref$initialIsVisible === void 0 ? false : _ref$initialIsVisible;
  var _React$useState = React.useState(initialIsVisible),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVisible = _React$useState2[0],
    setVisibility = _React$useState2[1];
  var hide = function hide(e) {
    setVisibility(false);
    if (isVisible) {
      afterHide(e);
    }
  };
  var show = function show() {
    setVisibility(true);
    if (!isVisible) {
      afterShow();
    }
  };
  var toggle = isVisible ? hide : show;
  return {
    hide: hide,
    isVisible: isVisible,
    show: show,
    toggle: toggle
  };
}

/* RENDER PROP */

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */
export function Visibility(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded);
  var visibility = useVisibility(props);
  return typeof children === 'function' ? children(visibility) : children;
}
//# sourceMappingURL=Visibility.js.map